var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-input',{attrs:{"type":"hidden","name":"username","value":_vm.username}}),_vm._v(" "),_c('a-input',{attrs:{"type":"text","value":_vm.username},on:{"change":_vm.handleInputChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }